import { EStatus } from '@libs/types';
import { styled } from '@mui/material/styles';

const PageWrapperStyled = styled('div')<{ $status?: EStatus }>({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
});

export default PageWrapperStyled;
